import { render, staticRenderFns } from "./TwoStep.vue?vue&type=template&id=520b43aa&scoped=true"
import script from "./TwoStep.vue?vue&type=script&lang=js"
export * from "./TwoStep.vue?vue&type=script&lang=js"
import style0 from "./TwoStep.vue?vue&type=style&index=0&id=520b43aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520b43aa",
  null
  
)

export default component.exports